<div class="modal inmodal fade in parcel-modal create-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title col-sm-8">Custom Report View</h4>
                </div>
                <div class="modal-body">
                    <div class="select-container m-b-sm">
                        <span class="select-header">Custom View</span>
                        <div>
                            <search-select [ngModel]="reportTemplate"
                                           name="reportTemplate"
                                           #templateSelect
                                           (ngModelChange)="changeTemplate($event)"
                                           [data]="reportTemplateSelect(reportTemplates)">
                            </search-select>
                            <input *ngIf="templateSelect.value == '0'"
                                   class="form-control"
                                   [(ngModel)]="templateName"
                                   name="templateName"
                                   placeholder="Template Name"
                                   maxlength="255" required>
                            <spinner [spinnerShow]="showSpinner"></spinner>
                        </div>
                        <div *ngIf="showEditPanel" class="dv-value-edit">
                            <button type="button" (click)="hideEditPanelSetter()">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <div class="select-container m-b-md">
                        <span class="select-header">Orientation</span>
                        <select class="form-control" name="orientation" [(ngModel)]="orientation">
                            <option [value]="'Portrait'">Portrait</option>
                            <option [value]="'Landscape'">Landscape</option>
                        </select>
                    </div>
                    <div class="form-group summernote"
                         id="summernote"
                         [ngClass]="{'invalid': form.submitted && !templateText}">
                        {{templateText}}
                    </div>
                    <div class="button-row display-flex">
                        <label class="img-checkbox m-r-md">
                            <input type="checkbox" id="save" name="save" [(ngModel)]="save">
                            <label for="save"><svg-checked></svg-checked></label>
                            <span>Save {{reportTemplate ? 'and Replace' : ''}}</span>
                        </label>
                        <search-select *ngIf="save && !reportTemplate && corporations.length > 1"
                                       [(ngModel)]="corporation"
                                       required
                                       [dropup]="true"
                                       name="corporation"
                                       class="corporation-select"
                                       [data]="reportTemplateSelect(corporations)">
                        </search-select>
                        <button type="submit"
                                (click)="onSubmit(form, true)"
                                class="btn btn-outer-primary mtv-primary-color mtv-primary-border">
                            Preview
                        </button>
                        <button type="submit" (click)="onSubmit(form, false)" class="btn btn-primary">
                            Get Report
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/report-generator/custom-report-view-modal/custom-report-view-modal.component.html